function capitalizeToken(token: string) {
  if (!token) {
    return "";
  }

  const [firstChar, ...rest] = Array.from(token.toLocaleLowerCase("pt-BR"));
  return `${firstChar.toLocaleUpperCase("pt-BR")}${rest.join("")}`;
}

export function normalizePersonName(value: string) {
  return value
    .trim()
    .replace(/\s+/g, " ")
    .split(" ")
    .filter(Boolean)
    .map((part) =>
      part
        .split(/([-'])/g)
        .map((token) =>
          token === "-" || token === "'" ? token : capitalizeToken(token),
        )
        .join(""),
    )
    .join(" ");
}
